import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Downshift from 'downshift'
import classNames from 'classnames'
import { renderItem } from './Dropdown.Helpers'
import { Results } from '../Base'
import PropTypes from 'prop-types'
import IconDown from '@components/Icon/IconDown'

class Dropdown extends Component {
  static propTypes = {
    valueIsId: PropTypes.bool,
    blue: PropTypes.bool,
    options: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
      .isRequired,
    itemToString: PropTypes.func,
    selectedItem: PropTypes.any,
    onChange: PropTypes.func,
    title: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    placeholder: PropTypes.string,
    disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    dropdownClassName: PropTypes.string,
    containerClassName: PropTypes.string,
    'data-cy': PropTypes.string
  }

  getSelectedOption = () => {
    const { selectedItem, options, valueIsId } = this.props
    // this is to avoid downshift bugs/weird behavior when undefined is passed as selected item
    if (selectedItem === undefined) return null
    if (valueIsId) {
      return options.find(o => o.id === selectedItem) || null
    }
    return selectedItem
  }

  render () {
    const {
      blue,
      options,
      itemToString,
      onChange,
      onFocus,
      onBlur,
      placeholder,
      title,
      fullRow,
      color,
      disabled,
      dropdownClassName,
      containerClassName
    } = this.props
    const placeholderText = placeholder || 'Select...'
    const currentItem = this.getSelectedOption()
    const inputText = currentItem
      ? renderItem(itemToString, currentItem)
      : placeholderText
    return (
      <Downshift
        selectedItem={currentItem}
        onChange={onChange}
        itemToString={itemToString}
        render={({
          isOpen,
          getButtonProps,
          getItemProps,
          getInputProps,
          highlightedIndex,
          selectedItem,
          inputValue
        }) => {
          const arrowIconClassName = classNames({
            'autocomplete__arrow-icon': true,
            'icon-animate': true,
            'icon--white': blue,
            'icon-rotate': isOpen
          })
          const classes = classNames({
            autocomplete__input: true,
            'autocomplete__input--dropdown': true,
            'autocomplete__input--blue': blue,
            'autocomplete__input--disabled': disabled,
            'autocomplete__input--placeholder': inputText === placeholderText,
            [dropdownClassName]: !!dropdownClassName
          })

          const containerClasses = containerClassName
            ? `${containerClassName} autocomplete__container`
            : 'autocomplete__container'

          // stopEventPropagation stops activating on click events
          // if the dropdown is inside of an element that has on click registered
          // like in the EPL component on Expert pipeline
          const buttonProps =
            !disabled &&
            getButtonProps({
              onClick: e => e.stopPropagation()
            })

          return (
            <div
              className={containerClasses}
              title={title}
              style={{
                background: color || undefined
              }}
            >
              <button
                className={classes}
                style={
                  color && {
                    background: color || undefined,
                    height: fullRow ? 54 : undefined,
                    border: color ? 'none' : undefined
                  }
                }
                {...buttonProps}
                onFocus={onFocus}
                onBlur={onBlur}
                disabled={disabled}
                data-cy={this.props['data-cy']}
              >
                {inputText}
              </button>

              <IconDown
                className={arrowIconClassName}
                style={fullRow && { marginTop: 10 }}
                {...buttonProps}
                disabled={disabled}
              />

              <Results
                blue={blue}
                showResultsOnEmptyInput
                getItemProps={getItemProps}
                highlightedIndex={highlightedIndex}
                inputValue={inputValue}
                isOpen={isOpen}
                items={options}
                itemToString={itemToString}
                selectedItem={selectedItem}
                showAllItemsOnEmpty
              />
            </div>
          )
        }}
      />
    )
  }
}

export default observer(Dropdown)
